{
  "version": 1,
  "asset_id": "3c8476dc-2b30-4b3a-8409-fda86462dd5d",
  "project_id": "4184c350-6181-49bc-a4ef-8461dd7b0d5c",
  "url": "/__l5e/assets-v1/3c8476dc-2b30-4b3a-8409-fda86462dd5d/eye-test-city-en.webp",
  "r2_key": "a/v1/4184c350-6181-49bc-a4ef-8461dd7b0d5c/3c8476dc-2b30-4b3a-8409-fda86462dd5d/eye-test-city-en.webp",
  "original_filename": "eye-test-city-en.webp",
  "size": 194906,
  "content_type": "image/webp",
  "created_at": "2026-06-04T15:06:19Z"
}
